export enum AmbidexChainId {
  HEDERA_MAINNET = 1099,
  HEDERA_TESTNET = 2099,
}

export const CURRENT_CHAIN_ID: AmbidexChainId = parseInt(
  process.env.REACT_APP_CHAIN_ID ?? AmbidexChainId.HEDERA_TESTNET.toString()
);
